export default "__VITE_ASSET__COW5BxRC__"